import { UserNotificationPreferencesStore } from '@stores/UserNotificationPreferencesStore';
import { NotificationPreferencesStore } from '@stores/NotificationPreferencesStore';
import { apiResponse } from '@stores';
import { useQuery } from '@tanstack/react-query';
import { Duration } from 'luxon';

export type CommunicationPreferencesView = {
  id: number;
  text: string;
  recommended: number;
  checked: {
    push: boolean;
    email: boolean;
    SMS: boolean;
  };
};

export enum NotificationType {
  PUSH = 1,
  EMAIL = 2,
  SMS = 3,
}

export class CommunicationPreferencesViewCreator {
  constructor(
    private readonly userNotificationPrefsStore: UserNotificationPreferencesStore = new UserNotificationPreferencesStore(),
    private readonly notificationPrefsStore: NotificationPreferencesStore = new NotificationPreferencesStore()
  ) {}

  async createView(): Promise<CommunicationPreferencesView[]> {
    const userPrefs = await apiResponse.handleApiResponse(() => this.userNotificationPrefsStore.read());
    const allPrefs = await apiResponse.handleApiResponse(() => this.notificationPrefsStore.readAll());

    return allPrefs.map((pref) => {
      const setItems = userPrefs.filter((x) => x.notificationPreferenceId === pref.id);

      return {
        id: pref.id,
        text: pref.name,
        recommended: pref.recommendedPreference,
        checked: {
          push: Boolean(setItems.some((x) => x.notificationTypeId === NotificationType.PUSH)),
          email: Boolean(setItems.some((x) => x.notificationTypeId === NotificationType.EMAIL)),
          SMS: Boolean(setItems.some((x) => x.notificationTypeId === NotificationType.SMS)),
        },
      } as CommunicationPreferencesView;
    });
  }
}

export const useCommunicationPreferencesViewCreator = () =>
  useQuery({
    queryKey: ['CommunicationPreferencesViewCreator'],
    queryFn: () => new CommunicationPreferencesViewCreator().createView(),
    staleTime: Duration.fromObject({ minutes: 1 }).milliseconds,
  });
